<div
  class="vendor-select"
  [class.vendor-select--warning]="showWarning()"
>
  @if (showWarning()) {
    <p class="vendor-select__notice" [innerHTML]="'vendorUploadTab.contactVendorFirst' | translate"></p>
  }

  @if (showButton()) {
    <button
      type="button"
      class="vendor-select__btn"
      (click)="openSelectQuoteModal()"
    >
      Select Quote
    </button>
  }
</div>
